"use client";

import { useLanguage } from "./language-provider";
import { v2Translations } from "./v2-translations";

export function useV2Translation() {
  const { lang } = useLanguage();
  const t = v2Translations[lang];
  return { lang, t };
}
